import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const BOStyrvardeMeny: IRutinInfo[] = [
  rutinInfos.rtnAktTypInstallningar,
  rutinInfos.rtnUsersBO,
  rutinInfos.rtnBegravningstyp,
  rutinInfos.rtnBokningsgrupper,
  rutinInfos.rtnVerksamhetstyper,
  rutinInfos.rtnGudstjansttyp,
  rutinInfos.rtnAktivitetskategori,
  rutinInfos.rtnRapportLayout,
  rutinInfos.rtnResurstyper,
  rutinInfos.rtnPlaneringskategorier,
  rutinInfos.rtnResursgrupp,
];

export default BOStyrvardeMeny;
